import { render, staticRenderFns } from "./IconZonneEnergieKruis.vue?vue&type=template&id=60631142"
import script from "./IconZonneEnergieKruis.vue?vue&type=script&lang=ts"
export * from "./IconZonneEnergieKruis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports